<template>
  <pvp-tooltip>
    <button
      class="rewards-id"
      @click="copyText(id)"
    >
      {{ title }}
    </button>
    <template slot="tooltip">
      {{
        isCopied
          ? $t('global.copied')
          : $t('global.copy')
      }}
    </template>
  </pvp-tooltip>
</template>

<script>
import { copyToClipboard } from '@utils/copyToClipboard';

export default {
  name: 'RewardsId',

  props: {
    id: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      isCopied: false,
    };
  },

  methods: {
    copyText(text) {
      copyToClipboard(text);
      this.isCopied = true;
      setTimeout(() => {
        this.isCopied = false;
      }, 500);
    },
  },
};
</script>

<style lang="scss" scoped>
.rewards-id {
  padding: 5px;
  background: linear-gradient(180deg, #2c2d2e 0%, #0e0f0f 100%);
  box-shadow: inset 0px 0px 0px 1px rgba(245, 245, 247, 0.12);
  border-radius: 0.375em;
  border: none;
  color: #f5f5f7;
}
</style>
